import { useState, useEffect } from 'react';
import { dgiiApi } from '../../api/dgii';
import {
	DocumentTextIcon,
	PlusIcon,
	ArrowPathIcon,
	MagnifyingGlassIcon,
	FunnelIcon,
	XMarkIcon,
	CheckCircleIcon,
	ClockIcon,
	ExclamationTriangleIcon,
	DocumentArrowDownIcon,
	TrashIcon,
	PencilIcon,
	ArrowDownTrayIcon,
	LockClosedIcon,
	LockOpenIcon,
	CalculatorIcon,
	EyeIcon,
} from '@heroicons/react/24/outline';

export default function IR17Manager() {
	const [formularios, setFormularios] = useState([]);
	const [formularios606, setFormularios606] = useState([]);
	const [loading, setLoading] = useState(true);
	const [selectedFormulario, setSelectedFormulario] = useState(null);
	const [registros, setRegistros] = useState([]);
	const [filtros, setFiltros] = useState({
		periodo: '',
		empresa: '',
		estado: '',
		busqueda: '',
	});
	const [showFiltros, setShowFiltros] = useState(true);
	const [showGenerarModal, setShowGenerarModal] = useState(false);
	const [formulario606Seleccionado, setFormulario606Seleccionado] = useState(null);
	const [generando, setGenerando] = useState(false);
	const [notification, setNotification] = useState(null);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [formularioToDelete, setFormularioToDelete] = useState(null);
	const [adminKey, setAdminKey] = useState('');
	const [deleteError, setDeleteError] = useState('');
	const [loadingRegistros, setLoadingRegistros] = useState(false);
	const [editingRegistro, setEditingRegistro] = useState(null);
	const [showEditModal, setShowEditModal] = useState(false);
	const [showDeleteRegistroModal, setShowDeleteRegistroModal] = useState(false);
	const [registroToDelete, setRegistroToDelete] = useState(null);
	const [editingFormulario, setEditingFormulario] = useState(null);
	const [showEditFormularioModal, setShowEditFormularioModal] = useState(false);
	const [vistaConsolidada, setVistaConsolidada] = useState(true); // true = por tipo, false = detalle
	const [filtros606, setFiltros606] = useState({
		empresa: '',
		periodo: '',
		busqueda: '',
	});
	const [formularios606Filtrados, setFormularios606Filtrados] = useState([]);
	const [loadingFormularios606, setLoadingFormularios606] = useState(false);
	const [empresas, setEmpresas] = useState([]);
	const [showFiltros606, setShowFiltros606] = useState(true);

	useEffect(() => {
		loadFormularios();
		loadFormularios606();
		loadEmpresas();
	}, [filtros]);

	useEffect(() => {
		// Filtrar formularios 606 cuando cambian los filtros o la lista
		if (formularios606.length > 0 || filtros606.empresa || filtros606.periodo || filtros606.busqueda) {
			filtrarFormularios606();
		}
	}, [filtros606, formularios606]);

	const loadFormularios = async () => {
		try {
			setLoading(true);
			const params = {};
			if (filtros.periodo) params.periodo = filtros.periodo;
			if (filtros.empresa) params.empresa = filtros.empresa;
			const data = await dgiiApi.getFormulariosIR17(params);
			setFormularios(Array.isArray(data) ? data : data.results || []);
		} catch (error) {
			console.error('Error cargando formularios IR-17:', error);
			showNotification('Error al cargar formularios IR-17', 'error');
		} finally {
			setLoading(false);
		}
	};

	const loadFormularios606 = async () => {
		try {
			setLoadingFormularios606(true);
			const data = await dgiiApi.getFormularios({ tipo: '606' });
			const formularios606Array = Array.isArray(data) ? data : data.results || [];
			// Solo formularios 606 que tengan datos completados
			const formulariosConDatos = formularios606Array.filter(f => 
				f.datos_completados && 
				f.datos_completados.compras && 
				Array.isArray(f.datos_completados.compras) &&
				f.datos_completados.compras.length > 0
			);
			setFormularios606(formulariosConDatos);
			// Inicializar filtrados con todos los formularios
			setFormularios606Filtrados(formulariosConDatos);
		} catch (error) {
			console.error('Error cargando formularios 606:', error);
		} finally {
			setLoadingFormularios606(false);
		}
	};

	const loadEmpresas = async () => {
		try {
			const data = await dgiiApi.getEmpresas();
			setEmpresas(Array.isArray(data) ? data : []);
		} catch (error) {
			console.error('Error cargando empresas:', error);
		}
	};

	const filtrarFormularios606 = () => {
		let filtrados = [...formularios606];

		// Filtro por empresa
		if (filtros606.empresa) {
			filtrados = filtrados.filter(f => 
				f.empresa && f.empresa.toString() === filtros606.empresa
			);
		}

		// Filtro por período
		if (filtros606.periodo) {
			filtrados = filtrados.filter(f => 
				f.periodo && f.periodo.includes(filtros606.periodo)
			);
		}

		// Filtro por búsqueda (empresa, período, RNC)
		if (filtros606.busqueda) {
			const busqueda = filtros606.busqueda.toLowerCase();
			filtrados = filtrados.filter(f => 
				(f.empresa_nombre && f.empresa_nombre.toLowerCase().includes(busqueda)) ||
				(f.periodo && f.periodo.toLowerCase().includes(busqueda)) ||
				(f.empresa_rnc && f.empresa_rnc.toLowerCase().includes(busqueda))
			);
		}

		setFormularios606Filtrados(filtrados);
	};

	const loadRegistros = async (formularioId) => {
		try {
			setLoadingRegistros(true);
			const data = await dgiiApi.getRegistrosIR17({ formulario: formularioId });
			setRegistros(Array.isArray(data) ? data : data.results || []);
		} catch (error) {
			console.error('Error cargando registros:', error);
			showNotification('Error al cargar registros', 'error');
		} finally {
			setLoadingRegistros(false);
		}
	};

	const handleGenerarDesde606 = async () => {
		if (!formulario606Seleccionado) {
			showNotification('Por favor selecciona un formulario 606', 'error');
			return;
		}

		try {
			setGenerando(true);
			const response = await dgiiApi.generarIR17Desde606(formulario606Seleccionado);
			
			if (response.formulario) {
				showNotification(
					`IR-17 generado exitosamente con ${response.detail || 'retenciones'}`,
					'success'
				);
				setShowGenerarModal(false);
				setFormulario606Seleccionado(null);
				loadFormularios();
			} else {
				showNotification(response.detail || 'Error al generar IR-17', 'error');
			}
		} catch (error) {
			console.error('Error generando IR-17:', error);
			const errorMsg = error.response?.data?.detail || 'Error al generar IR-17 desde 606';
			showNotification(errorMsg, 'error');
		} finally {
			setGenerando(false);
		}
	};

	const handleSelectFormulario = async (formulario) => {
		setSelectedFormulario(formulario);
		await loadRegistros(formulario.id);
	};

	const handleDeleteFormulario = (formulario) => {
		setFormularioToDelete(formulario);
		setShowDeleteModal(true);
		setAdminKey('');
		setDeleteError('');
	};

	const handleEditFormulario = (formulario) => {
		setEditingFormulario({ ...formulario });
		setShowEditFormularioModal(true);
	};

	const handleSaveFormulario = async () => {
		if (!editingFormulario) return;
		
		try {
			await dgiiApi.updateFormularioIR17(editingFormulario.id, editingFormulario);
			showNotification('Formulario actualizado exitosamente', 'success');
			setShowEditFormularioModal(false);
			setEditingFormulario(null);
			await loadFormularios();
			if (selectedFormulario?.id === editingFormulario.id) {
				const updated = await dgiiApi.getFormularioIR17(editingFormulario.id);
				setSelectedFormulario(updated);
			}
		} catch (error) {
			console.error('Error actualizando formulario:', error);
			showNotification('Error al actualizar formulario', 'error');
		}
	};

	const confirmDelete = async () => {
		if (!formularioToDelete) return;
		
		if (!adminKey.trim()) {
			setDeleteError('Debes proporcionar la clave de administrador para eliminar este formulario.');
			return;
		}

		try {
			await dgiiApi.deleteFormularioIR17(formularioToDelete.id);
			showNotification('Formulario eliminado exitosamente', 'success');
			setShowDeleteModal(false);
			setFormularioToDelete(null);
			setAdminKey('');
			if (selectedFormulario?.id === formularioToDelete.id) {
				setSelectedFormulario(null);
				setRegistros([]);
			}
			loadFormularios();
		} catch (error) {
			console.error('Error eliminando formulario:', error);
			const errorMessage = error.response?.data?.detail || error.response?.data?.message || 'Error al eliminar el formulario.';
			setDeleteError(errorMessage);
		}
	};

	const handleRefresh = async () => {
		if (!selectedFormulario) return;
		try {
			const refreshed = await dgiiApi.getFormularioIR17(selectedFormulario.id);
			setSelectedFormulario(refreshed);
			await loadRegistros(refreshed.id);
			showNotification('Datos actualizados correctamente', 'success');
		} catch (error) {
			console.error('Error actualizando formulario:', error);
			showNotification('Error al actualizar los datos', 'error');
		}
	};

	const handleCalcularTotales = async () => {
		if (!selectedFormulario) return;
		try {
			const updated = await dgiiApi.calcularTotalesIR17(selectedFormulario.id);
			setSelectedFormulario(updated);
			showNotification('Totales calculados correctamente', 'success');
		} catch (error) {
			console.error('Error calculando totales:', error);
			showNotification('Error al calcular totales', 'error');
		}
	};

	const handleExportPDF = async () => {
		if (!selectedFormulario) return;
		showNotification('Funcionalidad de exportación PDF en desarrollo', 'info');
		// TODO: Implementar exportación PDF
	};

	const handleExportExcel = async () => {
		if (!selectedFormulario) return;
		try {
			const blob = await dgiiApi.exportarIR17Excel(selectedFormulario.id);
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.download = `ir17_${selectedFormulario.periodo}_${new Date().toISOString().split('T')[0]}.xlsx`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
			showNotification('Archivo Excel exportado exitosamente', 'success');
		} catch (error) {
			console.error('Error exportando Excel:', error);
			showNotification('Error al exportar archivo Excel', 'error');
		}
	};

	const handleExportTXT = async () => {
		if (!selectedFormulario) return;
		try {
			const blob = await dgiiApi.exportarIR17TXT(selectedFormulario.id);
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.download = `IR17_${selectedFormulario.empresa_rnc}_${selectedFormulario.periodo.replace('-', '')}_${new Date().toISOString().split('T')[0]}.txt`;
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
			showNotification('Archivo TXT exportado exitosamente', 'success');
		} catch (error) {
			console.error('Error exportando TXT:', error);
			showNotification('Error al exportar archivo TXT', 'error');
		}
	};

	const handleAgregarRegistroManual = () => {
		if (!selectedFormulario) return;
		setEditingRegistro({
			formulario: selectedFormulario.id,
			tipo: 'retencion',
			tipo_retencion: '',
			rnc_cedula: '',
			nombre_beneficiario: '',
			tipo_id_beneficiario: '1',
			monto_pagado: '',
			porcentaje_retencion: '',
			monto_retenido: '',
			fecha_pago: '',
			ncf: '',
			concepto: '',
		});
		setShowEditModal(true);
	};

	const handleEditRegistro = (registro) => {
		setEditingRegistro({ ...registro });
		setShowEditModal(true);
	};

	const handleSaveRegistro = async () => {
		if (!editingRegistro || !selectedFormulario) return;
		
		try {
			if (editingRegistro.id) {
				// Actualizar registro existente
				await dgiiApi.updateRegistroIR17(editingRegistro.id, editingRegistro);
				showNotification('Registro actualizado exitosamente', 'success');
			} else {
				// Crear nuevo registro
				await dgiiApi.createRegistroIR17(editingRegistro);
				showNotification('Registro creado exitosamente', 'success');
			}
			setShowEditModal(false);
			setEditingRegistro(null);
			await loadRegistros(selectedFormulario.id);
			await handleRefresh();
		} catch (error) {
			console.error('Error guardando registro:', error);
			showNotification('Error al guardar registro: ' + (error.response?.data?.detail || error.message), 'error');
		}
	};

	const handleDeleteRegistro = (registro) => {
		setRegistroToDelete(registro);
		setShowDeleteRegistroModal(true);
	};

	const confirmDeleteRegistro = async () => {
		if (!registroToDelete || !selectedFormulario) return;
		
		try {
			await dgiiApi.deleteRegistroIR17(registroToDelete.id);
			showNotification('Registro eliminado exitosamente', 'success');
			setShowDeleteRegistroModal(false);
			setRegistroToDelete(null);
			await loadRegistros(selectedFormulario.id);
			await handleRefresh();
		} catch (error) {
			console.error('Error eliminando registro:', error);
			showNotification('Error al eliminar registro', 'error');
		}
	};

	const showNotification = (message, type = 'info') => {
		setNotification({ message, type });
		setTimeout(() => setNotification(null), 5000);
	};

	const formatCurrency = (amount) => {
		return new Intl.NumberFormat('es-DO', {
			style: 'currency',
			currency: 'DOP',
		}).format(amount || 0);
	};

	const formatDate = (dateString) => {
		if (!dateString) return '-';
		const date = new Date(dateString);
		return date.toLocaleDateString('es-DO');
	};

	return (
		<div className="min-h-screen bg-gray-50">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				{/* Header */}
				<div className="mb-6 pt-4 sm:pt-6">
					<h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-2">
						Gestión IR-17
					</h1>
					<p className="text-sm sm:text-base text-gray-600">
						Declaración Jurada de Otros Pagos y Retribuciones Complementarias. Genera, gestiona y exporta tus formularios IR-17.
					</p>
				</div>

				{/* Notification */}
				{notification && (
					<div className={`fixed top-20 right-4 z-50 p-4 rounded-lg shadow-lg ${
						notification.type === 'success' ? 'bg-green-500' :
						notification.type === 'error' ? 'bg-red-500' : 'bg-blue-500'
					} text-white`}>
						<div className="flex items-center justify-between">
							<span>{notification.message}</span>
							<button onClick={() => setNotification(null)}>
								<XMarkIcon className="h-5 w-5" />
							</button>
						</div>
					</div>
				)}
				{/* Sección de Filtros */}
				{showFiltros ? (
					<div className="mb-6 bg-white rounded-lg shadow-sm border border-gray-200">
						{/* Header de Filtros */}
						<div className="flex items-center justify-between px-4 sm:px-6 lg:px-8 py-3 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
							<div className="flex items-center gap-3">
								<h2 className="text-sm font-bold text-gray-800 uppercase tracking-wider">
									Filtros
								</h2>
							</div>
							<div className="flex items-center gap-2">
								<button
									onClick={() => setFiltros({ periodo: '', empresa: '', estado: '', busqueda: '' })}
									className="px-3 py-1.5 text-xs font-medium text-gray-600 hover:text-primary hover:bg-gray-100 rounded-lg transition-all"
								>
									Limpiar todo
								</button>
								<button
									onClick={() => setShowFiltros(false)}
									className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all shadow-sm"
									title="Ocultar filtros"
								>
									<FunnelIcon className="h-4 w-4" />
									<span>Ocultar</span>
								</button>
							</div>
						</div>

						{/* Contenido de Filtros */}
						<div className="p-4 sm:p-6 lg:p-8 bg-gray-50/50">
							<div className="grid grid-cols-1 md:grid-cols-4 gap-4">
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Período
									</label>
									<input
										type="text"
										placeholder="YYYY-MM"
										value={filtros.periodo}
										onChange={(e) => setFiltros({ ...filtros, periodo: e.target.value })}
										className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
									/>
								</div>
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Estado
									</label>
									<select
										value={filtros.estado}
										onChange={(e) => setFiltros({ ...filtros, estado: e.target.value })}
										className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
									>
										<option value="">Todos</option>
										<option value="borrador">Borrador</option>
										<option value="completado">Completado</option>
										<option value="presentado">Presentado</option>
									</select>
								</div>
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Buscar
									</label>
									<div className="relative">
										<MagnifyingGlassIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
										<input
											type="text"
											placeholder="Buscar..."
											value={filtros.busqueda}
											onChange={(e) => setFiltros({ ...filtros, busqueda: e.target.value })}
											className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
										/>
									</div>
								</div>
								<div className="flex items-end">
									<button
										onClick={() => setShowFiltros(false)}
										className="w-full px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
									>
										Ocultar
									</button>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="mb-6">
						<button
							onClick={() => setShowFiltros(true)}
							className="flex items-center gap-2 px-4 py-2 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all shadow-sm"
						>
							<FunnelIcon className="h-4 w-4" />
							<span>Mostrar Filtros</span>
						</button>
					</div>
				)}

				{/* Botón Generar desde 606 - Fuera de la tabla */}
				<div className="mb-4 flex justify-end">
					<button
						onClick={() => setShowGenerarModal(true)}
						className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
					>
						<PlusIcon className="h-5 w-5" />
						<span>Generar desde 606</span>
					</button>
				</div>

				{/* Lista de Formularios */}
				<div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-6">
					<div className="p-4 border-b border-gray-200">
						<h2 className="text-lg font-semibold text-gray-900">Formularios IR-17</h2>
					</div>

					{loading ? (
						<div className="p-8 text-center">
							<ArrowPathIcon className="h-8 w-8 animate-spin text-blue-600 mx-auto" />
							<p className="mt-2 text-gray-500">Cargando formularios...</p>
						</div>
					) : formularios.length === 0 ? (
						<div className="p-8 text-center">
							<DocumentTextIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
							<p className="text-gray-500">No hay formularios IR-17</p>
							<button
								onClick={() => setShowGenerarModal(true)}
								className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
							>
								Generar desde 606
							</button>
						</div>
					) : (
						<div className="overflow-x-auto">
							<table className="min-w-full divide-y divide-gray-200">
								<thead className="bg-gray-50">
									<tr>
										<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
											Período
										</th>
										<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
											Empresa
										</th>
										<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
											Estado
										</th>
										<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
											Total Retenciones
										</th>
										<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
											Total Retribuciones
										</th>
										<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
											Total General
										</th>
										<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
											Acciones
										</th>
									</tr>
								</thead>
								<tbody className="bg-white divide-y divide-gray-200">
									{formularios.map((formulario) => (
										<tr
											key={formulario.id}
											className={`hover:bg-gray-50 cursor-pointer ${
												selectedFormulario?.id === formulario.id ? 'bg-blue-50' : ''
											}`}
											onClick={() => handleSelectFormulario(formulario)}
										>
											<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
												{formulario.periodo}
											</td>
											<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
												{formulario.empresa_nombre || '-'}
											</td>
											<td className="px-6 py-4 whitespace-nowrap">
												<span className={`px-2 py-1 text-xs font-medium rounded-full ${
													formulario.estado === 'presentado' ? 'bg-green-100 text-green-800' :
													formulario.estado === 'completado' ? 'bg-blue-100 text-blue-800' :
													'bg-gray-100 text-gray-800'
												}`}>
													{formulario.estado_display || formulario.estado}
												</span>
											</td>
											<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
												{formatCurrency(formulario.total_retenciones)}
											</td>
											<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
												{formatCurrency(formulario.total_retribuciones)}
											</td>
											<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
												{formatCurrency(formulario.total_general)}
											</td>
											<td className="px-6 py-4 whitespace-nowrap text-sm">
												<div className="flex items-center gap-2">
													<button
														onClick={(e) => {
															e.stopPropagation();
															handleSelectFormulario(formulario);
														}}
														className="p-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
														title="Ver detalles"
													>
														<EyeIcon className="h-4 w-4" />
													</button>
													<button
														onClick={(e) => {
															e.stopPropagation();
															handleEditFormulario(formulario);
														}}
														className="p-1.5 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
														title="Editar formulario"
													>
														<PencilIcon className="h-4 w-4" />
													</button>
													<button
														onClick={(e) => {
															e.stopPropagation();
															handleDeleteFormulario(formulario);
														}}
														className="p-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
														title="Eliminar"
													>
														<TrashIcon className="h-4 w-4" />
													</button>
												</div>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}
				</div>

				{/* Formulario Seleccionado */}
				{selectedFormulario && (
					<div>
						{/* Header del formulario */}
						<div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
							<div className="flex items-start justify-between mb-3">
								<div>
									<h2 className="text-xl font-bold text-gray-900 mb-1">
										Formulario IR-17 - {selectedFormulario.periodo}
									</h2>
									{selectedFormulario.empresa_nombre && (
										<p className="text-sm font-medium text-gray-700 mb-2">
											{selectedFormulario.empresa_nombre}
										</p>
									)}
									<div className="flex items-center gap-3 text-sm text-gray-600">
										<span className="flex items-center gap-1">
											Estado: <span className={`font-medium ${
												selectedFormulario.estado === 'presentado' ? 'text-green-600' :
												selectedFormulario.estado === 'completado' ? 'text-blue-600' :
												'text-gray-600'
											}`}>{selectedFormulario.estado_display || selectedFormulario.estado}</span>
										</span>
										{selectedFormulario.formulario_606_periodo && (
											<>
												<span className="text-gray-400">•</span>
												<span>Generado desde 606 - {selectedFormulario.formulario_606_periodo}</span>
											</>
										)}
									</div>
								</div>
								{/* Botones de acción */}
								<div className="flex items-center gap-2">
									<button
										onClick={handleRefresh}
										className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
										title="Actualizar datos"
									>
										<ArrowPathIcon className="h-4 w-4" />
										<span className="hidden sm:inline">Actualizar</span>
									</button>
									<button
										onClick={handleCalcularTotales}
										className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
										title="Recalcular totales"
									>
										<CalculatorIcon className="h-4 w-4" />
										<span className="hidden sm:inline">Calcular Totales</span>
									</button>
									<button
										onClick={handleAgregarRegistroManual}
										className="flex items-center gap-2 px-3 py-2 text-sm text-white bg-primary hover:bg-primary/90 rounded-lg transition-colors"
										title="Agregar registro manual"
									>
										<PlusIcon className="h-4 w-4" />
										<span className="hidden sm:inline">Agregar Registro</span>
									</button>
									<div className="relative group">
										<button
											className="flex items-center gap-2 px-3 py-2 text-sm text-white bg-green-600 hover:bg-green-700 rounded-lg transition-colors"
											title="Exportar"
										>
											<ArrowDownTrayIcon className="h-4 w-4" />
											<span className="hidden sm:inline">Exportar</span>
										</button>
										<div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10">
											<button
												onClick={handleExportExcel}
												className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-t-lg"
											>
												Exportar Excel
											</button>
											<button
												onClick={handleExportPDF}
												className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
											>
												Exportar PDF
											</button>
											<button
												onClick={handleExportTXT}
												className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-b-lg"
											>
												Exportar TXT
											</button>
										</div>
									</div>
									<button
										onClick={() => {
											setSelectedFormulario(null);
											setRegistros([]);
										}}
										className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 hover:text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
										title="Cerrar"
									>
										<XMarkIcon className="h-4 w-4" />
										<span className="hidden sm:inline">Cerrar</span>
									</button>
								</div>
							</div>
							
							{/* Panel de diagnóstico */}
							<div className="mt-4 grid grid-cols-1 md:grid-cols-4 gap-4">
								<div className="bg-blue-50 rounded-lg p-3 border border-blue-200">
									<div className="text-xs font-medium text-blue-600 uppercase">Total Retenciones</div>
									<div className="text-lg font-bold text-blue-900">{formatCurrency(selectedFormulario.total_retenciones)}</div>
								</div>
								<div className="bg-purple-50 rounded-lg p-3 border border-purple-200">
									<div className="text-xs font-medium text-purple-600 uppercase">Total Retribuciones</div>
									<div className="text-lg font-bold text-purple-900">{formatCurrency(selectedFormulario.total_retribuciones)}</div>
								</div>
								<div className="bg-green-50 rounded-lg p-3 border border-green-200">
									<div className="text-xs font-medium text-green-600 uppercase">Total General</div>
									<div className="text-lg font-bold text-green-900">{formatCurrency(selectedFormulario.total_general)}</div>
								</div>
								<div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
									<div className="text-xs font-medium text-gray-600 uppercase">Registros</div>
									<div className="text-lg font-bold text-gray-900">{registros.length}</div>
								</div>
							</div>
						</div>

						{/* Registros del Formulario Seleccionado */}
						<div className="bg-white rounded-lg shadow-sm border border-gray-200">
							<div className="p-4 border-b border-gray-200 flex items-center justify-between">
								<h2 className="text-lg font-semibold text-gray-900">
									Registros - {selectedFormulario.periodo}
								</h2>
								<div className="flex items-center gap-2">
									<button
										onClick={() => setVistaConsolidada(!vistaConsolidada)}
										className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${
											vistaConsolidada
												? 'bg-blue-600 text-white'
												: 'bg-gray-200 text-gray-700 hover:bg-gray-300'
										}`}
									>
										Vista Consolidada
									</button>
									<button
										onClick={() => setVistaConsolidada(!vistaConsolidada)}
										className={`px-3 py-1.5 text-xs font-medium rounded-lg transition-colors ${
											!vistaConsolidada
												? 'bg-blue-600 text-white'
												: 'bg-gray-200 text-gray-700 hover:bg-gray-300'
										}`}
									>
										Vista Detalle
									</button>
								</div>
							</div>

							{loadingRegistros ? (
								<div className="p-8 text-center">
									<ArrowPathIcon className="h-8 w-8 animate-spin text-blue-600 mx-auto" />
									<p className="mt-2 text-gray-500">Cargando registros...</p>
								</div>
							) : registros.length === 0 ? (
								<div className="p-8 text-center text-gray-500">
									No hay registros en este formulario
								</div>
							) : vistaConsolidada ? (
								// Vista Consolidada por Tipo de Retención
								<div className="p-6">
									{(() => {
										// Agrupar registros por tipo de retención
										const consolidado = {};
										const tipoRetencionNombres = {
											'1': 'Alquileres',
											'2': 'Honorarios por Servicios Independientes',
											'3': 'Premios (Ley 253-12)',
											'4': 'Transferencia de Título y Propiedades',
											'5': 'Dividendos (Ley 253-12)',
											'6': 'Intereses a Personas Jurídicas o Entidades No Residentes (Ley 253-12)',
											'7': 'Intereses a Personas Jurídicas o Entidades No Residentes (Ley 57-2007)',
											'8': 'Intereses a Personas Físicas No Residentes (Ley 253-12)',
											'9': 'Intereses a Personas Físicas No Residentes (Leyes 57-2007 y 253-12)',
											'10': 'Remesas al Exterior (Ley 253-12)',
											'11': 'Intereses Pagados por Entidades No Financieras a Personas Físicas Residentes (Ley 253-12)',
											'12': 'Pagos a Proveedores del Estado (Ley 253-12)',
											'13': 'Juegos Telefónicos (Norma 08-2011)',
											'14': 'Ganancia de Capital (Norma 07-2011)',
											'15': 'Juegos Vía Internet (Ley 139-11, Art. 7)',
											'16': 'Otras Rentas (Ley 11-92, Art. 309 Lit. f)',
											'17': 'Otras Rentas (Decreto 139-98, Art. 70 Lit. a y b)',
											'18': 'Otras Retenciones (Norma 07-2007)',
											'19': 'Intereses Pagados por Entidades Financieras a Personas Jurídicas Residentes (Norma 13-2011)',
											'20': 'Intereses Pagados por Entidades Financieras a Personas Físicas Residentes (Ley 253-12)',
											'21': 'Adquisición de Bienes de Personas Físicas Dedicadas al Subsector de Ganadería de Carne Bovina que son Proveedores Informales (NORMA 04-25)',
											'22': 'Otras Retenciones (Suma de casillas 1+2+3+4+5+6+7+8+9+10+11+12+13+14+15+16+17+18+19+20+21)',
										};
										
										registros.filter(r => r.tipo === 'retencion').forEach(registro => {
											const tipo = registro.tipo_retencion || 'N/A';
											if (!consolidado[tipo]) {
											consolidado[tipo] = {
												tipo: tipo,
												nombre: tipoRetencionNombres[tipo] || `Tipo ${tipo}`,
												registros: [],
												totalPagado: 0,
												totalRetenido: 0,
												cantidad: 0,
												beneficiarios: new Set(),
												porcentajeRetencion: null
											};
											}
											consolidado[tipo].registros.push(registro);
											consolidado[tipo].totalPagado += parseFloat(registro.monto_pagado || 0);
											consolidado[tipo].totalRetenido += parseFloat(registro.monto_retenido || 0);
											consolidado[tipo].cantidad += 1;
											consolidado[tipo].beneficiarios.add(registro.rnc_cedula);
											// El porcentaje de retención debe ser el mismo para todos los registros del mismo tipo
											// Usar el porcentaje del registro si está disponible, de lo contrario usar el estándar según el tipo
											if (!consolidado[tipo].porcentajeRetencion) {
												if (registro.porcentaje_retencion) {
													consolidado[tipo].porcentajeRetencion = parseFloat(registro.porcentaje_retencion);
												} else if (registro.tipo_retencion) {
													// Porcentajes estándar según tipo de retención (deben coincidir con el backend)
													const porcentajesEstandar = {
														'1': 10.00,   // Alquileres
														'2': 10.00,   // Honorarios por Servicios Independientes
														'3': 25.00,   // Premios (Ley 253-12)
														'4': 2.00,    // Transferencia de Título y Propiedades
														'5': 10.00,   // Dividendos (Ley 253-12)
														'6': 10.00,   // Intereses a Personas Jurídicas No Residentes (Ley 253-12)
														'7': 5.00,    // Intereses a Personas Jurídicas No Residentes (Ley 57-2007)
														'8': 10.00,   // Intereses a Personas Físicas No Residentes (Ley 253-12)
														'9': 5.00,    // Intereses a Personas Físicas No Residentes (Leyes 57-2007 y 253-12)
														'10': 27.00,  // Remesas al Exterior (Ley 253-12)
														'11': 10.00,  // Intereses Pagados por Entidades No Financieras a Personas Físicas Residentes (Ley 253-12)
														'12': 5.00,   // Pagos a Proveedores del Estado (Ley 253-12)
														'13': 5.00,   // Juegos Telefónicos (Norma 08-2011)
														'14': 1.00,   // Ganancia de Capital (Norma 07-2011)
														'15': 10.00,  // Juegos Vía Internet (Ley 139-11, Art. 7)
														'16': 10.00,  // Otras Rentas (Ley 11-92, Art. 309 Lit. f)
														'17': 2.00,   // Otras Rentas (Decreto 139-98, Art. 70 Lit. a y b)
														'18': 2.00,   // Otras Retenciones (Norma 07-2007)
														'19': 1.00,   // Intereses Pagados por Entidades Financieras a Personas Jurídicas Residentes (Norma 13-2011)
														'20': 10.00,  // Intereses Pagados por Entidades Financieras a Personas Físicas Residentes (Ley 253-12)
														'21': 1.00,   // Adquisición de Bienes de Personas Físicas Dedicadas al Subsector de Ganadería de Carne Bovina (NORMA 04-25)
														'22': 0.00,   // Otras Retenciones (Suma - no tiene tasa propia)
													};
													consolidado[tipo].porcentajeRetencion = porcentajesEstandar[registro.tipo_retencion] || 0;
												}
											}
										});
										
										return (
											<div className="space-y-4">
												{Object.keys(consolidado).sort().map(tipo => {
													const datos = consolidado[tipo];
													return (
														<div key={tipo} className="border border-gray-200 rounded-lg p-4 bg-gray-50">
															<div className="flex items-center justify-between mb-3">
																<div>
																	<h3 className="text-lg font-semibold text-gray-900">
																		Tipo {tipo} - {datos.nombre}
																	</h3>
																	<p className="text-sm text-gray-600 mt-1">
																		{datos.cantidad} registro{datos.cantidad !== 1 ? 's' : ''} • {datos.beneficiarios.size} beneficiario{datos.beneficiarios.size !== 1 ? 's' : ''} único{datos.beneficiarios.size !== 1 ? 's' : ''}
																	</p>
																</div>
																<div className="text-right">
																	<div className="text-sm text-gray-600">Total Retenido</div>
																	<div className="text-xl font-bold text-blue-600">{formatCurrency(datos.totalRetenido)}</div>
																</div>
															</div>
															<div className="grid grid-cols-3 gap-4 mt-4 pt-4 border-t border-gray-200">
																<div>
																	<div className="text-xs text-gray-500 uppercase">Total Pagado</div>
																	<div className="text-lg font-semibold text-gray-900">{formatCurrency(datos.totalPagado)}</div>
																</div>
																<div>
																	<div className="text-xs text-gray-500 uppercase">Total Retenido</div>
																	<div className="text-lg font-semibold text-blue-600">{formatCurrency(datos.totalRetenido)}</div>
																</div>
																<div>
																	<div className="text-xs text-gray-500 uppercase">% Retención</div>
																	<div className="text-lg font-semibold text-gray-900">
																		{datos.porcentajeRetencion 
																			? `${parseFloat(datos.porcentajeRetencion).toFixed(2)}%` 
																			: '0%'
																		}
																	</div>
																</div>
															</div>
														</div>
													);
												})}
											</div>
										);
									})()}
								</div>
							) : (
							// Vista Detalle (tabla completa)
							<div className="overflow-x-auto">
								<table className="min-w-full divide-y divide-gray-200">
									<thead className="bg-gray-50">
										<tr>
											<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
												Tipo
											</th>
											<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
												Tipo Retención
											</th>
											<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
												Beneficiario
											</th>
											<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
												RNC/Cédula
											</th>
											<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
												Monto Pagado
											</th>
											<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
												% Retención
											</th>
											<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
												Monto Retenido
											</th>
											<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
												Fecha Pago
											</th>
											<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
												NCF
											</th>
											<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider sticky right-0 bg-gray-50">
												Acciones
											</th>
										</tr>
									</thead>
									<tbody className="bg-white divide-y divide-gray-200">
										{registros.map((registro) => (
											<tr key={registro.id} className="hover:bg-gray-50">
												<td className="px-6 py-4 whitespace-nowrap text-sm">
													<span className={`px-2 py-1 text-xs font-medium rounded-full ${
														registro.tipo === 'retencion' 
															? 'bg-blue-100 text-blue-800' 
															: 'bg-purple-100 text-purple-800'
													}`}>
														{registro.tipo_display}
													</span>
												</td>
												<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
													{registro.tipo_retencion_display || registro.tipo_retencion || '-'}
												</td>
												<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
													{registro.nombre_beneficiario}
												</td>
												<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
													{registro.rnc_cedula}
												</td>
												<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
													{formatCurrency(registro.monto_pagado)}
												</td>
												<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
													{registro.porcentaje_retencion ? `${parseFloat(registro.porcentaje_retencion).toFixed(2)}%` : '-'}
												</td>
												<td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
													{formatCurrency(registro.monto_retenido)}
												</td>
												<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
													{formatDate(registro.fecha_pago)}
												</td>
												<td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
													{registro.ncf || '-'}
												</td>
												<td className="px-6 py-4 whitespace-nowrap text-sm sticky right-0 bg-white z-40 shadow-sm border-l border-gray-300">
													<div className="flex items-center gap-1.5">
														<button
															onClick={(e) => {
																e.stopPropagation();
																handleEditRegistro(registro);
															}}
															className="p-1.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
															title="Editar registro"
														>
															<PencilIcon className="h-4 w-4" />
														</button>
														<button
															onClick={(e) => {
																e.stopPropagation();
																handleDeleteRegistro(registro);
															}}
															className="p-1.5 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
															title="Eliminar registro"
														>
															<TrashIcon className="h-4 w-4" />
														</button>
													</div>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
							)}
						</div>
					</div>
				)}
			</div>

			{/* Modal Generar desde 606 */}
			{showGenerarModal && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
					<div className="bg-white rounded-lg shadow-xl max-w-6xl w-full mx-4 my-8 max-h-[90vh] flex flex-col">
						<div className="p-6 border-b border-gray-200 flex-shrink-0">
							<div className="flex justify-between items-center">
								<h2 className="text-xl font-bold text-gray-900">Generar IR-17 desde Formulario 606</h2>
								<button
									onClick={() => {
										setShowGenerarModal(false);
										setFormulario606Seleccionado(null);
										setFiltros606({ empresa: '', periodo: '', busqueda: '' });
									}}
									className="text-gray-400 hover:text-gray-600"
								>
									<XMarkIcon className="h-6 w-6" />
								</button>
							</div>
						</div>
						
						{/* Filtros */}
						<div className="p-4 border-b border-gray-200 bg-gray-50 flex-shrink-0">
							<div className="flex items-center justify-between mb-3">
								<button
									onClick={() => setShowFiltros606(!showFiltros606)}
									className="flex items-center text-sm text-gray-700 hover:text-gray-900"
								>
									<FunnelIcon className="h-4 w-4 mr-1" />
									{showFiltros606 ? 'Ocultar Filtros' : 'Mostrar Filtros'}
								</button>
								{formularios606Filtrados.length > 0 && (
									<span className="text-sm text-gray-600">
										{formularios606Filtrados.length} formulario{formularios606Filtrados.length !== 1 ? 's' : ''} encontrado{formularios606Filtrados.length !== 1 ? 's' : ''}
									</span>
								)}
							</div>
							
							{showFiltros606 && (
								<div className="grid grid-cols-1 md:grid-cols-4 gap-3">
									<div>
										<label className="block text-xs font-medium text-gray-700 mb-1">
											Empresa
										</label>
										<select
											value={filtros606.empresa}
											onChange={(e) => setFiltros606({ ...filtros606, empresa: e.target.value })}
											className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
										>
											<option value="">Todas las empresas</option>
											{empresas.map((emp) => (
												<option key={emp.id} value={emp.id}>
													{emp.nombre} ({emp.rnc})
												</option>
											))}
										</select>
									</div>
									<div>
										<label className="block text-xs font-medium text-gray-700 mb-1">
											Período
										</label>
										<input
											type="text"
											placeholder="Ej: 2025-10"
											value={filtros606.periodo}
											onChange={(e) => setFiltros606({ ...filtros606, periodo: e.target.value })}
											className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
										/>
									</div>
									<div className="md:col-span-2">
										<label className="block text-xs font-medium text-gray-700 mb-1">
											Búsqueda
										</label>
										<div className="relative">
											<MagnifyingGlassIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
											<input
												type="text"
												placeholder="Buscar por empresa, período o RNC..."
												value={filtros606.busqueda}
												onChange={(e) => setFiltros606({ ...filtros606, busqueda: e.target.value })}
												className="w-full pl-8 pr-2 py-1.5 text-sm border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
											/>
										</div>
									</div>
								</div>
							)}
						</div>

						{/* Tabla de Formularios */}
						<div className="flex-1 overflow-y-auto p-6">
							{loadingFormularios606 ? (
								<div className="text-center py-8">
									<div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
									<p className="mt-2 text-sm text-gray-600">Cargando formularios...</p>
								</div>
							) : formularios606Filtrados.length === 0 ? (
								<div className="text-center py-8">
									<p className="text-gray-500">No se encontraron formularios 606 con datos completados.</p>
								</div>
							) : (
								<div className="overflow-x-auto">
									<table className="min-w-full divide-y divide-gray-200">
										<thead className="bg-gray-50 sticky top-0">
											<tr>
												<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
													Seleccionar
												</th>
												<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
													Empresa
												</th>
												<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
													RNC
												</th>
												<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
													Período
												</th>
												<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
													Facturas
												</th>
												<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
													Total Facturado
												</th>
												<th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
													Estado
												</th>
											</tr>
										</thead>
										<tbody className="bg-white divide-y divide-gray-200">
											{formularios606Filtrados.map((f) => {
												const totalFacturado = f.datos_completados?.compras?.reduce((sum, compra) => {
													return sum + (parseFloat(compra.total_factura) || 0);
												}, 0) || 0;
												const isSelected = formulario606Seleccionado === f.id.toString();
												
												return (
													<tr 
														key={f.id} 
														className={`hover:bg-gray-50 cursor-pointer transition-colors ${isSelected ? 'bg-blue-50 border-l-4 border-blue-600' : ''}`}
														onClick={() => setFormulario606Seleccionado(f.id.toString())}
													>
														<td className="px-4 py-4 whitespace-nowrap">
															<input
																type="radio"
																name="formulario606"
																checked={isSelected}
																onChange={() => setFormulario606Seleccionado(f.id.toString())}
																className="h-4 w-4 text-blue-600 focus:ring-blue-500"
															/>
														</td>
														<td className="px-4 py-4 whitespace-nowrap">
															<div className="text-sm font-medium text-gray-900">
																{f.empresa_nombre || 'N/A'}
															</div>
														</td>
														<td className="px-4 py-4 whitespace-nowrap">
															<div className="text-sm text-gray-500">
																{f.empresa_rnc || 'N/A'}
															</div>
														</td>
														<td className="px-4 py-4 whitespace-nowrap">
															<div className="text-sm font-medium text-gray-900">
																{f.periodo || 'N/A'}
															</div>
														</td>
														<td className="px-4 py-4 whitespace-nowrap">
															<div className="text-sm text-gray-900">
																{f.datos_completados?.compras?.length || 0}
															</div>
														</td>
														<td className="px-4 py-4 whitespace-nowrap">
															<div className="text-sm font-medium text-gray-900">
																{formatCurrency(totalFacturado)}
															</div>
														</td>
														<td className="px-4 py-4 whitespace-nowrap">
															<span className={`px-2 py-1 text-xs font-medium rounded-full ${
																f.estado === 'completado' 
																	? 'bg-green-100 text-green-800' 
																	: f.estado === 'borrador'
																	? 'bg-yellow-100 text-yellow-800'
																	: 'bg-gray-100 text-gray-800'
															}`}>
																{f.estado_display || f.estado || 'N/A'}
															</span>
														</td>
													</tr>
												);
											})}
										</tbody>
									</table>
								</div>
							)}
						</div>

						{/* Footer con acciones */}
						<div className="p-6 border-t border-gray-200 flex-shrink-0 bg-gray-50">
							{formulario606Seleccionado && (
								<div className="mb-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
									<p className="text-sm text-gray-700">
										<strong>Formulario seleccionado:</strong> Se generará un formulario IR-17 con todas las retenciones ISR encontradas en el formulario 606 seleccionado.
									</p>
								</div>
							)}
							<div className="flex justify-end space-x-3">
								<button
									onClick={() => {
										setShowGenerarModal(false);
										setFormulario606Seleccionado(null);
										setFiltros606({ empresa: '', periodo: '', busqueda: '' });
									}}
									className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
								>
									Cancelar
								</button>
								<button
									onClick={handleGenerarDesde606}
									disabled={!formulario606Seleccionado || generando}
									className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
								>
									{generando ? 'Generando...' : 'Generar IR-17'}
								</button>
							</div>
						</div>
					</div>
				</div>
			)}

			{/* Modal Eliminar Formulario */}
			{showDeleteModal && formularioToDelete && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
					<div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
						<div className="p-6 border-b border-gray-200">
							<h2 className="text-xl font-bold text-gray-900">Eliminar Formulario IR-17</h2>
						</div>
						<div className="p-6">
							<p className="text-gray-700 mb-4">
								¿Estás seguro de que deseas eliminar el formulario IR-17 del período <strong>{formularioToDelete.periodo}</strong>?
							</p>
							<p className="text-sm text-red-600 mb-4">
								Esta acción no se puede deshacer. Se eliminarán todos los registros asociados.
							</p>
							<div className="mb-4">
								<label className="block text-sm font-medium text-gray-700 mb-2">
									Clave de Administrador
								</label>
								<input
									type="password"
									value={adminKey}
									onChange={(e) => {
										setAdminKey(e.target.value);
										setDeleteError('');
									}}
									className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
									placeholder="Ingresa tu clave de administrador"
								/>
								{deleteError && (
									<p className="mt-2 text-sm text-red-600">{deleteError}</p>
								)}
							</div>
						</div>
						<div className="p-6 border-t border-gray-200 flex justify-end space-x-3">
							<button
								onClick={() => {
									setShowDeleteModal(false);
									setFormularioToDelete(null);
									setAdminKey('');
									setDeleteError('');
								}}
								className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
							>
								Cancelar
							</button>
							<button
								onClick={confirmDelete}
								className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
							>
								Eliminar
							</button>
						</div>
					</div>
				</div>
			)}

			{/* Modal Editar Registro */}
			{showEditModal && editingRegistro && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
					<div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
						<div className="p-6 border-b border-gray-200">
							<h2 className="text-xl font-bold text-gray-900">Editar Registro IR-17</h2>
						</div>
						<div className="p-6">
							<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
								{/* Tipo de Retención - PRIMERO */}
								{editingRegistro.tipo === 'retencion' && (
									<div className="md:col-span-2">
										<label className="block text-sm font-medium text-gray-700 mb-1">
											Tipo de Retención <span className="text-red-500">*</span>
										</label>
										<select
											value={editingRegistro.tipo_retencion || ''}
											onChange={(e) => {
												const tipoRetencion = e.target.value;
												// Porcentajes estándar según tipo de retención IR-17 (DGII - según tabla oficial)
												// IMPORTANTE: Todos los registros del mismo tipo deben tener el mismo porcentaje
												const porcentajes = {
													'1': 10.00,   // Alquileres
													'2': 10.00,   // Honorarios por Servicios Independientes
													'3': 25.00,   // Premios (Ley 253-12)
													'4': 2.00,    // Transferencia de Título y Propiedades
													'5': 10.00,   // Dividendos (Ley 253-12)
													'6': 10.00,   // Intereses a Personas Jurídicas No Residentes (Ley 253-12)
													'7': 5.00,    // Intereses a Personas Jurídicas No Residentes (Ley 57-2007)
													'8': 10.00,   // Intereses a Personas Físicas No Residentes (Ley 253-12)
													'9': 5.00,    // Intereses a Personas Físicas No Residentes (Leyes 57-2007 y 253-12)
													'10': 27.00,  // Remesas al Exterior (Ley 253-12)
													'11': 10.00,  // Intereses Pagados por Entidades No Financieras a Personas Físicas Residentes (Ley 253-12)
													'12': 5.00,   // Pagos a Proveedores del Estado (Ley 253-12)
													'13': 5.00,   // Juegos Telefónicos (Norma 08-2011)
													'14': 1.00,   // Ganancia de Capital (Norma 07-2011)
													'15': 10.00,  // Juegos Vía Internet (Ley 139-11, Art. 7)
													'16': 10.00,  // Otras Rentas (Ley 11-92, Art. 309 Lit. f)
													'17': 2.00,   // Otras Rentas (Decreto 139-98, Art. 70 Lit. a y b)
													'18': 2.00,   // Otras Retenciones (Norma 07-2007)
													'19': 1.00,   // Intereses Pagados por Entidades Financieras a Personas Jurídicas Residentes (Norma 13-2011)
													'20': 10.00,  // Intereses Pagados por Entidades Financieras a Personas Físicas Residentes (Ley 253-12)
													'21': 1.00,   // Adquisición de Bienes de Personas Físicas Dedicadas al Subsector de Ganadería de Carne Bovina (NORMA 04-25)
													'22': 0.00,   // Otras Retenciones (Suma - no tiene tasa propia)
												};
												const porcentaje = porcentajes[tipoRetencion] || 0;
												const montoPagado = parseFloat(editingRegistro.monto_pagado) || 0;
												const montoRetenido = (montoPagado * porcentaje) / 100;
												setEditingRegistro({ 
													...editingRegistro, 
													tipo_retencion: tipoRetencion,
													porcentaje_retencion: porcentaje,
													monto_retenido: montoRetenido
												});
											}}
											className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
											required
										>
											<option value="">-- Seleccionar Tipo de Retención --</option>
											<option value="1">1 - Alquileres (10%)</option>
											<option value="2">2 - Honorarios por Servicios Independientes (10%)</option>
											<option value="3">3 - Premios (Ley 253-12) (25%)</option>
											<option value="4">4 - Transferencia de Título y Propiedades (2%)</option>
											<option value="5">5 - Dividendos (Ley 253-12) (10%)</option>
											<option value="6">6 - Intereses a Personas Jurídicas o Entidades No Residentes (Ley 253-12) (10%)</option>
											<option value="7">7 - Intereses a Personas Jurídicas o Entidades No Residentes (Ley 57-2007) (5%)</option>
											<option value="8">8 - Intereses a Personas Físicas No Residentes (Ley 253-12) (10%)</option>
											<option value="9">9 - Intereses a Personas Físicas No Residentes (Leyes 57-2007 y 253-12) (5%)</option>
											<option value="10">10 - Remesas al Exterior (Ley 253-12) (27%)</option>
											<option value="11">11 - Intereses Pagados por Entidades No Financieras a Personas Físicas Residentes (Ley 253-12) (10%)</option>
											<option value="12">12 - Pagos a Proveedores del Estado (Ley 253-12) (5%)</option>
											<option value="13">13 - Juegos Telefónicos (Norma 08-2011) (5%)</option>
											<option value="14">14 - Ganancia de Capital (Norma 07-2011) (1%)</option>
											<option value="15">15 - Juegos Vía Internet (Ley 139-11, Art. 7) (10%)</option>
											<option value="16">16 - Otras Rentas (Ley 11-92, Art. 309 Lit. f) (10%)</option>
											<option value="17">17 - Otras Rentas (Decreto 139-98, Art. 70 Lit. a y b) (2%)</option>
											<option value="18">18 - Otras Retenciones (Norma 07-2007) (2%)</option>
											<option value="19">19 - Intereses Pagados por Entidades Financieras a Personas Jurídicas Residentes (Norma 13-2011) (1%)</option>
											<option value="20">20 - Intereses Pagados por Entidades Financieras a Personas Físicas Residentes (Ley 253-12) (10%)</option>
											<option value="21">21 - Adquisición de Bienes de Personas Físicas Dedicadas al Subsector de Ganadería de Carne Bovina (NORMA 04-25) (1%)</option>
											<option value="22">22 - Otras Retenciones (Suma de casillas 1+2+3+4+5+6+7+8+9+10+11+12+13+14+15+16+17+18+19+20+21) (0%)</option>
										</select>
									</div>
								)}
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Beneficiario <span className="text-red-500">*</span>
									</label>
									<input
										type="text"
										value={editingRegistro.nombre_beneficiario || ''}
										onChange={(e) => setEditingRegistro({ ...editingRegistro, nombre_beneficiario: e.target.value })}
										className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
										required
									/>
								</div>
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										RNC/Cédula
									</label>
									<input
										type="text"
										value={editingRegistro.rnc_cedula || ''}
										onChange={(e) => setEditingRegistro({ ...editingRegistro, rnc_cedula: e.target.value })}
										className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
									/>
								</div>
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Monto Pagado <span className="text-red-500">*</span>
									</label>
									<input
										type="number"
										step="0.01"
										value={editingRegistro.monto_pagado || ''}
										onChange={(e) => {
											const montoPagado = parseFloat(e.target.value) || 0;
											const porcentaje = parseFloat(editingRegistro.porcentaje_retencion) || 0;
											const montoRetenido = (montoPagado * porcentaje) / 100;
											setEditingRegistro({ 
												...editingRegistro, 
												monto_pagado: montoPagado,
												monto_retenido: montoRetenido
											});
										}}
										className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
										required
									/>
								</div>
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Porcentaje Retención
									</label>
									<input
										type="number"
										step="0.01"
										value={editingRegistro.porcentaje_retencion || ''}
										readOnly
										className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100"
										title="Se calcula automáticamente según el tipo de retención seleccionado"
									/>
								</div>
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Monto Retenido
									</label>
									<input
										type="number"
										step="0.01"
										value={editingRegistro.monto_retenido || ''}
										readOnly
										className="w-full px-3 py-2 border border-gray-300 rounded-md bg-gray-100"
										title="Se calcula automáticamente: Monto Pagado × Porcentaje Retención / 100"
									/>
								</div>
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Fecha de Pago
									</label>
									<input
										type="date"
										value={editingRegistro.fecha_pago ? editingRegistro.fecha_pago.split('T')[0] : ''}
										onChange={(e) => setEditingRegistro({ ...editingRegistro, fecha_pago: e.target.value })}
										className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
									/>
								</div>
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										NCF
									</label>
									<input
										type="text"
										value={editingRegistro.ncf || ''}
										onChange={(e) => setEditingRegistro({ ...editingRegistro, ncf: e.target.value })}
										className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
									/>
								</div>
								<div className="md:col-span-2">
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Concepto
									</label>
									<textarea
										value={editingRegistro.concepto || ''}
										onChange={(e) => setEditingRegistro({ ...editingRegistro, concepto: e.target.value })}
										className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
										rows={3}
										placeholder="Descripción del concepto del pago o retribución (opcional)"
									/>
								</div>
							</div>
						</div>
						<div className="p-6 border-t border-gray-200 flex justify-end space-x-3">
							<button
								onClick={() => {
									setShowEditModal(false);
									setEditingRegistro(null);
								}}
								className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
							>
								Cancelar
							</button>
							<button
								onClick={handleSaveRegistro}
								className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
							>
								Guardar Cambios
							</button>
						</div>
					</div>
				</div>
			)}

			{/* Modal Eliminar Registro */}
			{showDeleteRegistroModal && registroToDelete && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
					<div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
						<div className="p-6 border-b border-gray-200">
							<h2 className="text-xl font-bold text-gray-900">Eliminar Registro</h2>
						</div>
						<div className="p-6">
							<p className="text-gray-700 mb-4">
								¿Estás seguro de que deseas eliminar el registro de <strong>{registroToDelete.nombre_beneficiario}</strong>?
							</p>
							<p className="text-sm text-red-600">
								Esta acción no se puede deshacer.
							</p>
						</div>
						<div className="p-6 border-t border-gray-200 flex justify-end space-x-3">
							<button
								onClick={() => {
									setShowDeleteRegistroModal(false);
									setRegistroToDelete(null);
								}}
								className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
							>
								Cancelar
							</button>
							<button
								onClick={confirmDeleteRegistro}
								className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
							>
								Eliminar
							</button>
						</div>
					</div>
				</div>
			)}

			{/* Modal Editar Formulario */}
			{showEditFormularioModal && editingFormulario && (
				<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
					<div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
						<div className="p-6 border-b border-gray-200">
							<h2 className="text-xl font-bold text-gray-900">Editar Formulario IR-17</h2>
						</div>
						<div className="p-6">
							<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Período
									</label>
									<input
										type="text"
										value={editingFormulario.periodo || ''}
										onChange={(e) => setEditingFormulario({ ...editingFormulario, periodo: e.target.value })}
										className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
										placeholder="YYYY-MM"
									/>
								</div>
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Estado
									</label>
									<select
										value={editingFormulario.estado || 'borrador'}
										onChange={(e) => setEditingFormulario({ ...editingFormulario, estado: e.target.value })}
										className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
									>
										<option value="borrador">Borrador</option>
										<option value="completado">Completado</option>
										<option value="presentado">Presentado</option>
									</select>
								</div>
								<div className="md:col-span-2">
									<label className="block text-sm font-medium text-gray-700 mb-1">
										Notas
									</label>
									<textarea
										value={editingFormulario.notas || ''}
										onChange={(e) => setEditingFormulario({ ...editingFormulario, notas: e.target.value })}
										rows={4}
										className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
										placeholder="Notas adicionales sobre el formulario..."
									/>
								</div>
							</div>
						</div>
						<div className="p-6 border-t border-gray-200 flex justify-end space-x-3">
							<button
								onClick={() => {
									setShowEditFormularioModal(false);
									setEditingFormulario(null);
								}}
								className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
							>
								Cancelar
							</button>
							<button
								onClick={handleSaveFormulario}
								className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
							>
								Guardar Cambios
							</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
